import { Link, useNavigate } from 'react-router-dom';
import { useIsMobile } from '../hooks/useIsMobile';
import NavMenu from './NavMenu';
import ProfileDropdown from './ProfileDropdown';
import WhatsNew from './WhatsNew';

const Header = ({ isLoggedIn, locationInfo, isMenuOpen, setIsMenuOpen, handleLogout, onMenuSelect, activeRoute, userInfo }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <header className="fixed top-0 left-0 right-0 z-[200] bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-4 lg:px-0 py-2">
        <div className="flex items-center justify-between h-16">
          {/* Logo and Company Name (Left) */}
          <div className="flex items-center">
            <Link to="/" data-attr="nav-home" className="flex items-center space-x-3">
              <svg
                className="h-10 w-10 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
              <span className="text-2xl font-bold tracking-tight">
                <span className="text-white">dentara</span>
                <span className="text-teal-200">tech</span>
                <span className="text-teal-300">.com</span>
              </span>
            </Link>
            {(locationInfo?.company?.name ||
              locationInfo?.company_name ||
              (typeof locationInfo?.company === "string" &&
                locationInfo?.company)) && (
              <div className="hidden sm:flex items-center ml-4">
                <span className="text-teal-300 mx-3">|</span>
                <span className="font-medium text-teal-100">
                  {locationInfo.company?.name ||
                    locationInfo.company_name ||
                    locationInfo.company}
                </span>
              </div>
            )}
          </div>

          {/* Mobile Menu Toggle (Right on Mobile) */}
          <div className="flex items-center sm:hidden">
            <button
              data-attr="nav-mobile-menu-toggle"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 text-white hover:text-teal-200 focus:outline-none transition-colors duration-200"
              aria-label="Toggle menu"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={
                    isMenuOpen
                      ? "M6 18L18 6M6 6l12 12"
                      : "M4 6h16M4 12h16m-7 6h7"
                  }
                />
              </svg>
            </button>
          </div>

          {/* Desktop Navigation and Auth Buttons */}
          <div
            className={`${
              isMenuOpen ? "block" : "hidden"
            } sm:flex sm:items-center sm:justify-end sm:flex-1 sm:ml-8 absolute sm:static top-16 left-0 w-full sm:w-auto bg-secondary sm:bg-transparent px-4 sm:px-0 py-4 sm:py-0 z-40 transition-all duration-300 ease-in-out`}
          >
            {isLoggedIn ? (
              <>
                {/* Center NavMenu on Desktop */}
                <div className="flex-1 flex justify-center sm:justify-start">
                  {!isMobile && (
                    <NavMenu
                      onMenuSelect={onMenuSelect}
                      activeRoute={activeRoute}
                    />
                  )}
                </div>
                {/* Profile and Logout (Right on Desktop) */}
                <nav className="flex flex-col items-start sm:flex-row sm:items-center">
                  <WhatsNew setIsMenuOpen={setIsMenuOpen} />
                  <ProfileDropdown
                    handleLogout={handleLogout}
                    setIsMenuOpen={setIsMenuOpen}
                    locationInfo={locationInfo}
                  />
                </nav>
              </>
            ) : (
              <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-3 sm:space-y-0 items-center sm:items-end">
                <button
                  data-attr="nav-login"
                  onClick={() => {
                    navigate("/login");
                    setIsMenuOpen(false);
                  }}
                  className="bg-secondary text-white px-5 py-2 rounded-full font-medium hover:bg-secondary/90/85 w-full sm:w-auto text-center transition-all duration-300 ease-in-out transform hover:scale-105"
                >
                  Login
                </button>
                <button
                  data-attr="nav-signup"
                  onClick={() => {
                    navigate("/signup");
                    setIsMenuOpen(false);
                  }}
                  className="bg-white text-primary px-5 py-2 rounded-full font-medium hover:bg-accent-teal-light-bg border border-teal-600 w-full sm:w-auto text-center transition-all duration-300 ease-in-out transform hover:scale-105"
                >
                  Sign Up
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;